const validate = values => {
	const errors = {};
	if (!values.vineyards || !values.vineyards.length) {
	  errors.vineyards = { _error: 'Debe ingresarse al menos un viñedo.' };
	} else {
	  const vineyardsArrayErrors = [];
	  values.vineyards.forEach((vineyard, vineyardIndex) => {
		const vineyardsErrors = {};
		if (!vineyard || !vineyard.vineyard_id) {
			vineyardsErrors.vineyard_id = 'Este campo es obligatorio';
			vineyardsArrayErrors[vineyardIndex] = vineyardsErrors;
		}
		if (!vineyard || !/^([a-zA-Z0-9]+)$/.test(vineyard.vineyard_id)) {
			vineyardsErrors.vineyard_id = 'Solo caracteres y números'
			vineyardsArrayErrors[vineyardIndex] = vineyardsErrors
		}
	  });
	  if (vineyardsArrayErrors.length) {
		errors.vineyards = vineyardsArrayErrors;
	  }
	}
	return errors;
  };

  export default validate;



/** WEBPACK FOOTER **
 ** ./src/components/Validations/submitValidationsVineyardsForm.js
 **/